import React from 'react';
import PropTypes from 'prop-types';
import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material';

const recapRows = [
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Signed SOAP Note: Headache Signed by: Doctor MD'
  },
  {
    date: '06/24/2026',
    description: 'Route document: Labor created by: Medical Doctor MD'
  }
];

const DataHx = ({ className }) => {
  return (
    <Box className={className} sx={{ width: '100%' }}>
      <Table
        sx={{
          tableLayout: 'fixed',
          '& .MuiTableCell-root': {
            borderBottom: '1px solid #EEEEEE',
            padding: '0 16px',
            height: 40,
            fontSize: 12,
            color: '#424242'
          }
        }}>
        <TableBody>
          {recapRows.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: '#FCF8F2'
                }
              }}>
              <TableCell
                sx={{
                  width: 90,
                  fontWeight: 600,
                  whiteSpace: 'nowrap'
                }}>
                {row.date}
              </TableCell>

              <TableCell>{row.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

DataHx.propTypes = {
  className: PropTypes.string
};

export default DataHx;
